import script from "./TressAccountRegisterPrivateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccountRegisterPrivateForm.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccountRegisterPrivateForm.vue?vue&type=style&index=0&id=12b16518&lang=scss"

const __exports__ = script;

export default __exports__